import { useEffect, useState } from "react";
import api from "@/lib/api";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Bell } from "lucide-react";

export function NotificationBell({ activeTenantId }) {
  const [items, setItems] = useState([]);

  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});

  useEffect(() => {
    if (!activeTenantId) return;
    load();
    const interval = setInterval(load, 30000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTenantId]);

  const unread = items.filter((n) => !n.read).length;

  const markRead = async (n) => {
    if (!n.id || n.read) return;
    await api.put(`/notifications/${n.id}/read`);
    setItems((prev) => prev.map((i) => (i.id === n.id ? { ...i, read: true } : i)));
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="relative outline-none" data-testid="notification-bell-trigger">
          <Bell className="h-5 w-5 text-[#71717A]" strokeWidth={2} />
          {unread > 0 && (
            <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-[#EF4444] text-white text-[9px] grid place-items-center" data-testid="notification-unread-badge">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80" data-testid="notification-list">
        <DropdownMenuLabel>Notificaciones</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {items.length === 0 ? (
          <div className="px-2 py-4 text-xs text-[#A1A1AA] text-center">Sin notificaciones.</div>
        ) : (
          items.slice(0, 15).map((n) => (
            <DropdownMenuItem key={n.id} onClick={() => markRead(n)} className={`text-xs items-start gap-2 py-2 ${!n.read ? "bg-[#0055FF]/5" : ""}`} data-testid={`notification-item-${n.id}`}>
              {!n.read && <span className="h-1.5 w-1.5 rounded-full bg-[#0055FF] mt-1 shrink-0" />}
              <span className="whitespace-normal">{n.message}</span>
            </DropdownMenuItem>
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
